// YouTube URL parsing / validation / embed normalization.
// Supports: youtube.com/watch?v=, youtu.be/, youtube.com/shorts/,
// youtube.com/embed/, youtube-nocookie.com. Original URL is kept in the DB;
// this is only used for playback.

const PATTERNS = [
  /(?:youtube\.com\/watch\?(?:.*&)?v=)([\w-]{11})/,
  /(?:youtu\.be\/)([\w-]{11})/,
  /(?:youtube\.com\/shorts\/)([\w-]{11})/,
  /(?:youtube(?:-nocookie)?\.com\/embed\/)([\w-]{11})/,
  /(?:youtube\.com\/v\/)([\w-]{11})/,
];

export function getYouTubeId(url) {
  if (!url || typeof url !== 'string') return null;
  for (const re of PATTERNS) {
    const m = url.match(re);
    if (m && m[1]) return m[1];
  }
  try {
    const u = new URL(url);
    const v = u.searchParams.get('v');
    if (v && /^[\w-]{11}$/.test(v)) return v;
  } catch {
    /* not a parseable URL */
  }
  return null;
}

export function isValidYouTube(url) {
  return !!getYouTubeId(url);
}

export function toEmbedUrl(url) {
  const id = getYouTubeId(url);
  return id ? `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1&playsinline=1` : null;
}
